import request from "../plugins/axios";

/**
 * 医生
 */
//  医生列表
export function doctorList(params) {
	return request({
		url: '/scrm/DoctorList',
		method: 'GET',
		params
	})
}

// 医生分享
export function doctorShare(params) {
	return request({
		url: '/scrm/DoctorShare',
		method: 'GET',
		params
	})
}
